import * as turf from "@turf/turf"

export function getNearestFeature(data, position, maxDistance) {
    if (!data || !data.features || !data.features.length || !position) {
        return null
    }

    const targetPoint = turf.point(position)
    const nearestPoint = turf.nearestPoint(targetPoint, data)
    const distance = turf.distance(targetPoint, nearestPoint)
    if (distance > maxDistance) {
        return null
    }

    return nearestPoint
}

export function getNearestFeatures(collection, position, radius) {
    if (!collection || !collection.features || !collection.features.length || !position) {
        return null
    }

    const targetPoint = turf.point(position)
    const nearby = collection.features
        .map(f => ({
            feature: f,
            distance: turf.distance(targetPoint, turf.point(f.geometry.coordinates), { units: "kilometers" }),
        }))
        .filter(({ distance }) => distance <= radius)
        .sort((a, b) => a.distance - b.distance)
        .map(({ feature }) => feature)


    return nearby
}